import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import dayjs from "dayjs";
import axiosInstance from "../../../api/axios";
import UserTable from "../table/UserTable";
import { notifyError } from "../../../components/common/toast/ToastFunc";

const Requests = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {
      const formattedData = data?.map(item => {
        return {
          ...item,
          id: item?.id.replace(/-/g, ""),
          role: item?.role.charAt(0).toUpperCase() + item?.role.slice(1).toLowerCase(),
          dob: dayjs(item?.dob).format('MM/DD/YYYY'),
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError("Something went wrong.");
    }
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/customer/user-info/get-all', {
          params: {
            type: "All",
            is_deleted: "True"
          }
        });
        formatData(response.data.data);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [formatData, reFetch]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>Requests</Typography>
      <UserTable
        data={data}
        loading={loading}
        actionLoading={actionLoading}
        setActionLoading={setActionLoading}
        reFetch={reFetch}
        setReFetch={setReFetch}
        isRequestList={true}
      />
    </Box>
  );
};

export default Requests;
